import React from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Zoom from "@mui/material/Zoom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { TransitionProps } from "@mui/material/transitions";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  // eslint-disable-next-line no-undef
  ref: React.Ref<unknown>
) {
  return <Zoom in ref={ref} {...props} />;
});

interface AppMedialViewerProps {
  media: any;
  onClose: () => void;
  isOpen: boolean;
}

const AppMedialViewer: React.FC<AppMedialViewerProps> = ({
  media,
  onClose,
  isOpen,
}) => {
  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paperFullScreen": {
          display: "flex",
          flexDirection: "column",
        },
      }}
      TransitionComponent={Transition}
    >
      <Box
        sx={{
          position: "relative",
          color: (theme) => theme.palette.common.white,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <IconButton
          sx={{
            color: (theme) => theme.palette.common.white,
            position: "absolute",
            left: 10,
            top: 10,
            zIndex: 1,
          }}
          onClick={onClose}
          size="large"
        >
          <HighlightOffIcon />
        </IconButton>
        <img src={media} alt={"detail view"} />
      </Box>
    </Dialog>
  );
};

export default AppMedialViewer;
